<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import home from '@/views/home/index'
export default {
  name: 'App',
  components: {
    home
  }
}
</script>

<style lang='scss'>
// @import '~normalize.css/normalize.css';// normalize.css 样式格式化
/* 引入公共scss */
@import './assets/css/common.scss';
@import './assets/css/public.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue